import React from 'react';

const EditorUsfm = ({usfmText, setUsfmText}) => {
  const handleTextChange = (e) => {
    setUsfmText(e.target.value);
  };

  return (
    <div style={{ width: '100%', height: '100%', padding: '0' }}>
      <textarea
        value={usfmText}
        onChange={handleTextChange}
        style={{
          width: '100%',
          height: '100%',
          padding: '16px',
          fontSize: '16px',
          fontFamily: 'Consolas, Monaco, "Courier New", monospace',
          lineHeight: '1.5',
          border: 'none',
          outline: 'none',
          resize: 'none',
          backgroundColor: '#1e1e1e',
          color: '#d4d4d4',
          boxSizing: 'border-box',
        }}
        placeholder="Enter USFM content here..."
        spellCheck={false}
      />
    </div>
  );
};

export default EditorUsfm;
